import MessageBusService from './MessageBusService';
import Query from './Query';
import AsyncEvent from './AsyncEvent';
import log from 'loglevel';

var listQuery = {};

class QueryService {
	constructor(session) {
		this.msgbus = new MessageBusService(session);
	}

	createQuery(queryString, callback, fail_callback) {
		this.msgbus.send('org.araqne.logdb.msgbus.LogQueryPlugin.createQuery', {
			'query': queryString
		})
		.onSuccess((resp) => {
			var query = new Query(this.msgbus, queryString, resp);
			listQuery[resp.id] = query;
			callback(query);
		})
		.onFailure((m) => {
			log.debug('failed');
			console.warn('failed to create', queryString);
			fail_callback(m);
		});
	}

	startQuery(queryId, pageSize, isStreaming) {
		if(isStreaming){
			listQuery[queryId].startStreamQuery();
		}else{
			listQuery[queryId].start(pageSize);
		}
	}

	getQuery(queryId) {
		return listQuery[queryId];
	}

	getResult(id, offset, limit = 100) {
		return this.msgbus.send('org.araqne.logdb.msgbus.LogQueryPlugin.getResult', {
			id: id,
			offset: offset,
			limit: limit,
			return_type: true
		});
	}

	removeQuery(queryId) {
		var self = this;
		return new AsyncEvent((resolve, reject) => {
			self.msgbus.send('org.araqne.logdb.msgbus.LogQueryPlugin.removeQuery', {
				id: queryId
			})
			.onSuccess((resp) => {
				listQuery[queryId] = null;
				delete listQuery[queryId];
				resolve(resp);
			})
			.onFailure((a, b) => {
				listQuery[queryId] = null;
				delete listQuery[queryId];
				reject(a, b);
			});

			self.msgbus.unsubscribe('logdb-query-' + queryId);
		});
	}

	getQueries() {
		return listQuery;
	}
}

export default QueryService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/QueryService.js